import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfigurationService, DialogService, HttpService, Identity } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';
import { LinkTransportsDialogComponent } from 'src/tmc-yard/components/link-transports/component/link-transports-dialog.component';
import { LinkTransportDetails } from 'src/tmc-yard/components/link-transports/link-transports.model';
import { TransportDetails } from 'src/tmc-yard/components/transport-details/transport-details-model';

@Component({
  selector: 'app-link-transport-dialog-action',
  templateUrl: './link-transport-dialog-action.component.html',
  styleUrls: ['./link-transport-dialog-action.component.scss']
})
export class LinkTransportDialogActionComponent {

  @Input() disabled = false;

  @Input() transportId: number;

  @Input() asButton = false;

  @Output() onChange = new EventEmitter();

  TMCClientParameters = TMCClientParameters;

  constructor(
    public translationService: TranslationService,
    private dialogService: DialogService,
    private httpService: HttpService,
    public cps: ConfigurationService
  ) {}

  public linkTransports() {

    if (this.disabled) {
      return;
    }


    this.loadLinkableTransports({ id: this.transportId }).subscribe(
      details => {
        const dialogRef = this.dialogService.openLarge(LinkTransportsDialogComponent, {
          details: details,
          // panelClass: DialogLayout.panelClass,
          autoFocus: false
        });
        dialogRef.afterClosed().subscribe(
          r => {
            this.onChange.next();
          }
        );
      },
      error => {
        // result.error('Error loading linkable transports');
      }
    );

  }

  private loadLinkableTransports(sourceTransport: Identity): Observable<LinkTransportDetails> {
    return this.httpService.postWithContext(environment.linkTransportsEndpoint + '', sourceTransport);
  }
}
